export default {
  Modules: {
    GroupName: "Modules",
    GroupId: "0",
    Cockpit: { Name: "Cockpit", Id: "10" },
    ContentEditor: { Name: "Content Editor", Id: "100" },
    VisualLink: { Name: "Visual Link", Id: "101" },
    ClassificationSelector: { Name: "Classification Selector", Id: "102" },
    ArticleNoGenerator: { Name: "ArticleNoGenerator", Id: "103" },
    ChannelCreator: { Name: "Channel Creator", Id: "110" },
    AttributeManager: { Name: "Attribute Manager", Id: "120" },
    UserManager: { Name: "User Manager", Id: "130" },
    ConfigurationManager: { Name: "Configuration Manager", Id: "140" },
    Gpsr: { Name: "GPSR", Id: "155" },
    TranslationManager: { Name: "Translation Manager", Id: "150" },
    WorkManager: { Name: "Work Manager", Id: "160" },
    AutomationServer: { Name: "Automation Server", Id: "145" },
    Unknown: { Name: "Unknown", Id: "1337" }
  },

  Imports: {
    GroupName: "Imports",
    GroupId: "1",
    Pro: { Name: "PRO", Id: "200" },
    SQL: { Name: "SQL", Id: "205" },
    Access: { Name: "Access", Id: "210" },
    Excel: { Name: "Excel", Id: "220" },
    Text: { Name: "Text", Id: "230" },
    ExternalSource: { Name: "ExternalSource", Id: "240" },
    eDCConnector: { Name: "eDC Connector", Id: "245" },
    BMEcat: { Name: "BMEcat®", Id: "250" },
    DatanormConverter: { Name: "DATANORM Converter", Id: "260" },
    Datanorm: { Name: "DATANORM Import", Id: "261" }
  },

  Exports: {
    GroupName: "Exports",
    GroupId: "2",
    Pro: { Name: "PRO", Id: "300" },
    Access: { Name: "Access (Beta)", Id: "311" },
    Excel: { Name: "Excel", Id: "321" },
    Text: { Name: "Text", Id: "331" },
    XML: { Name: "XML", Id: "336" },
    JSON: { Name: "JSON", Id: "337" },
    BMEcatExportG3: { Name: "BMEcat® G3.5", Id: "340" },
    BMEcat: { Name: "BMEcat®", Id: "342" },
    TradeProExportG35: { Name: "TradePro G3.5", Id: "350" },
    TradeProExport: { Name: "TradePro Connector", Id: "351" },
    TradeProNext: { Name: "TradePro Connector", Id: "352" },
    Ariba: { Name: "Ariba Connector", Id: "356" },
    PDFCatalog: { Name: "PDF Catalog", Id: "360" },
    FlipCatalog: { Name: "FlipCatalog", Id: "370" },
    iPadCatalog: { Name: "iPadCatalog", Id: "380" },
    Datanorm: { Name: "DATANORM Export", Id: "390" },
    DatanormConverter: { Name: "DATANORM Converter", Id: "391" }
  },

  PrintCatalogs: {
    GroupName: "PrintCatalogs",
    GroupId: "3",
    FastPage: { Name: "FastPage", Id: "400" },
    PublishManager: { Name: "Publish Manager", Id: "410" },
    PublishCatalogBuilder: { Name: "Publish Catalog Builder", Id: "420" },
    PublishCatalogCreator: { Name: "Publish Catalog Creator", Id: "430" },
    PublishDirect: { Name: "Publish Direct", Id: "440" },
    BmecatPrinter: { Name: "BMEcat Printer", Id: "450" }
  },

  DataQuality: {
    GroupName: "DataQuality",
    GroupId: "4",
    QualityGates: { Name: "Quality Gates", Id: "540" },
    MediaAssetCleanUp: { Name: "Media Cleanup", Id: "550" },
    ArticleMerge: { Name: "Article Merge", Id: "560" },
    ReportCenter: { Name: "Report Center", Id: "570" }
  },

  OtherModules: {
    GroupName: "OtherModules",
    GroupId: "5",
    ErpSync: { Name: "Erp Sync", Id: "901" },
    FastPageServer: { Name: "Fast Page Server", Id: "902" },
    MamSync: { Name: "MAM Sync", Id: "903" },
    MediaConverter: { Name: "Media Converter", Id: "904" },
    PriceCalculator: { Name: "Price Calculcator", Id: "905" },
    QualityGatesEvaluator: { Name: "Quality Gates", Id: "906" },
    SmartSnippetReplacer: { Name: "Smart Snippet Replacer", Id: "907" },
    UpdaterDefaultUnits: { Name: "Default Units Updater", Id: "908" }
  },

  Unknown: {
    GroupName: "Unknown",
    GroupId: "",
    Unknown: { Name: "Unknown", Id: "1337" },
    History: { Name: "History", Id: "1338" },
    ErpAttributesAccess: { Name: "ErpAttributesAccess", Id: "1339" },
    MeDaProMdm: { Name: "MeDaProMdm", Id: "1340" },
    PriceCalculation: { Name: "PriceCalculation", Id: "1342" },
    DeepLConnector: { Name: "DeepLConnector", Id: "1343" },
    MeDaProMam: { Name: "MeDaProMam", Id: "1344" },
    WebClient: { Name: "WebClient", Id: "2000" }
  }
} as Record<string, any>;
